import { render, staticRenderFns } from "./Function.vue?vue&type=template&id=0fba963c&scoped=true"
import script from "./Function.vue?vue&type=script&lang=js"
export * from "./Function.vue?vue&type=script&lang=js"
import style0 from "./Function.vue?vue&type=style&index=0&id=0fba963c&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0fba963c",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/drone/src/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('0fba963c')) {
      api.createRecord('0fba963c', component.options)
    } else {
      api.reload('0fba963c', component.options)
    }
    module.hot.accept("./Function.vue?vue&type=template&id=0fba963c&scoped=true", function () {
      api.rerender('0fba963c', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/service/investment-advisor/components/Function.vue"
export default component.exports